import { render, staticRenderFns } from "./main-screen.vue?vue&type=template&id=19ba4cd5"
import script from "./main-screen.vue?vue&type=script&lang=js"
export * from "./main-screen.vue?vue&type=script&lang=js"
import style0 from "./main-screen.vue?vue&type=style&index=0&id=19ba4cd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports